module.exports = __webpack_public_path__ + "img/dangjian.c2a52d5e.jpg";